// @ts-check
import React, { useState } from 'react';

import { useDispatch, useSelector } from 'react-redux';
import { editRecipientNameAction } from '../redux/actions/settings-actions';

import { Formik } from 'formik';
import * as Yup from 'yup';

import { makeStyles } from '@material-ui/core/styles';
import { Button, CircularProgress } from '@material-ui/core';

import Checkbox from '@material-ui/core/Checkbox';
import FormGroup from '@material-ui/core/FormGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormControl from '@material-ui/core/FormControl';
import FormLabel from '@material-ui/core/FormLabel';

const useStyles = makeStyles((theme) => ({
  root: {
    '& > *': {
      marginTop: theme.spacing(1),
      marginBottom: theme.spacing(1)
    }
  },
  sectionHeading: {
    margin: theme.spacing(2)
  },
  margin: {
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(1)
  },
  formButtons: {
    marginTop: theme.spacing(0),
    paddingBottom: theme.spacing(1)
  },
  errorText: {
    color: '#f44336',
    textAlign: 'center',
    display: 'block',
    margin: theme.spacing(3)
  }
}));

function EditRecipientNameForm(props) {
  const classes = useStyles();
  const { error, loading } = useSelector((state) => state.loading);

  const { values, errors, touched, handleSubmit, handleChange, handleBlur } = props;
  console.log('values', values);
  /**
   * @param {string} name
   */
  const formikProps = (name, initialValue = '') => ({
    name: name,
    value: typeof values[name] !== 'undefined' ? values[name] : initialValue,
    onChange: handleChange,
    onBlur: handleBlur,
    error: touched[name] && Boolean(errors[name]),
    helperText: touched[name] ? errors[name] : ''
  });

  return (
    <form className={classes.root} noValidate autoComplete="off" onSubmit={handleSubmit}>
      <FormControl component="fieldset">
        <FormLabel component="legend">
          Select the delivery type/s that require a recipient name
        </FormLabel>
        <FormGroup aria-label="recipient_name" {...formikProps('recipient_name')}>
          <FormControlLabel value={'sog'} control={<Checkbox />} name="selected" label="SOG" />
          <FormControlLabel value={'otp'} control={<Checkbox />} name="selected" label="OTP" />
        </FormGroup>
      </FormControl>

      <div className={classes.formButtons}>
        {!loading && (
          <>
            <Button
              className={classes.margin}
              type="submit"
              variant="contained"
              size="large"
              color="primary"
              fullWidth={true}
            >
              Save Changes
            </Button>
          </>
        )}

        {loading && (
          <Button
            className={classes.margin}
            variant="contained"
            size="large"
            color="primary"
            fullWidth={true}
          >
            <CircularProgress color="inherit" size={26} />
          </Button>
        )}

        {error && (
          <div>
            <span className={classes.errorText}>{error.message}</span>
          </div>
        )}
      </div>
    </form>
  );
}

export function EditRecipientNameFormComponent({
  recipient_name,
  openBackdrop,
  closeBackdrop,
  showSnackbar,
  handleClose
}) {
  const dispatch = useDispatch();

  const values = {
    enabled: false,
    selected: []
  };

  const submit = (data, actions) => {
    openBackdrop();

    let value;

    if (data.selected.length === 0) {
      value = {
        enabled: false,
        selected: []
      };
    } else {
      value = {
        enabled: true,
        selected: data.selected
      };
    }

    const { resetForm } = actions;
    resetForm();
    const props = { resetForm, closeBackdrop, showSnackbar, handleClose };
    dispatch(editRecipientNameAction(value, props));
  };

  return (
    <Formik initialValues={values} onSubmit={submit}>
      {(props) => <EditRecipientNameForm {...props} />}
    </Formik>
  );
}
